<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>
              {{ source.name }}
            </h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Name *</label>
                  <div class="col-md-10">
                    <input
                      id="name"
                      v-model="entity.name"
                      type="text"
                      placeholder="Enter name"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Body *</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group">
                  <button class="btn btn-success" @click="save">
                    Save Vocabulary
                    <span class="btn-loader" style="display: none;" />
                  </button>

                  <div class="saving-alerts" style="margin-top: 20px;">
                    <div class="alert alert-success" style="display: none;">
                      Vocabulary has modified successful!
                    </div>
                    <div class="alert alert-danger" style="display: none;">
                      {{ saveErrorMessage }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Terms />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Terms from './Terms';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';

export default {
  name: 'VocabularyEdit',

  components: {
    Terms,
  },

  mixins: [EditPageMixin],

  methods: {
    isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      return true;
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}vocabularies/${this.$route.params.id}`)
        .then((response) => {
          this.source = response.data;
          this.entity = _.cloneDeep(response.data);
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        })
        .catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting data request' });
          console.error('Error in get single vocabulary query', error);
        });
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      postFormData.append('body', this.entity.body ? this.entity.body : null);

      return this.$apiHttp.post(`${this.$config.app_api.prefix}vocabularies/${this.$route.params.id}`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(() => {
        this.$_successSave();
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in update vocabulary query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?83427f2a